var map = {
	"./beast.png": 882,
	"./derpy_bald_guy.png": 883,
	"./dwarf_f.png": 884,
	"./dwarf_m.png": 885,
	"./elf_f.png": 886,
	"./elf_m.png": 887,
	"./fane.png": 888,
	"./human_f.png": 889,
	"./human_m.png": 890,
	"./ifan.png": 891,
	"./knight.png": 892,
	"./lizard_f.png": 893,
	"./lizard_m.png": 894,
	"./lohse.png": 895,
	"./magister_waifu.png": 896,
	"./obama.png": 897,
	"./pip.png": 898,
	"./red_prince.png": 899,
	"./sebille.png": 900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 881;